import { useCallback } from 'react';
import { FormFieldsData, ModalForm, NumberInput } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import { useNewProjectService } from 'domain/shared/newProject';
import { ProjectManagementHealthcheckModalProps } from './types';

const ForecastBudgetCompletionUpdateModal = ({
  data,
  isOpen,
  onClose,
  refetchControlsData,
}: ProjectManagementHealthcheckModalProps) => {
  const { putProjectBudgetForecast, budgetCompletionValidationSchema } = useNewProjectService();

  const submitFormFunc = useCallback(
    async (stateData: FormFieldsData) => {
      const updatedForecastData = {
        forecastCompletionBudgetHours: stateData.forecast?.forecastCompletionBudgetHours,
      };
      return putProjectBudgetForecast(data.id, updatedForecastData);
    },
    [putProjectBudgetForecast, data.id],
  );

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Forecast budget at completion">
      <ModalForm
        closeModal={onClose}
        modalOpen={isOpen}
        submitFormFunc={submitFormFunc}
        getValidationSchemaFunc={budgetCompletionValidationSchema}
        afterSubmit={{ execute: () => refetchControlsData() }}
        getDataFunc={async () => data}
      >
        <NumberInput
          source="forecast.forecastCompletionBudgetHours"
          label="Forecast Budget at Completion (hours) "
          slotProps={{ htmlInput: { min: 0 } }}
        />
      </ModalForm>
    </Modal>
  );
};

export default ForecastBudgetCompletionUpdateModal;
